var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-title"},[_c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('h1',{domProps:{"innerHTML":_vm._s(_vm.main)}},[(_vm.icon)?_c('i',{class:_vm.icon}):_vm._e()]),_c('h2',[_vm._v(_vm._s(_vm.sub))])])],1),_c('hr')],1)}
var staticRenderFns = []

export { render, staticRenderFns }